import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import MuiDialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const Dialog = ({ title, isOpen, handleClose, children, ...rest }) => {
  return (
    <MuiDialog onClose={handleClose} open={isOpen} {...rest}>
      <DialogTitle disableTypography onClose={handleClose}>
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </MuiDialog>
  );
};

export default Dialog;
